import { Action, createReducer, on } from '@ngrx/store';
import { CustomerState } from './customer.state';

import * as customerActions from '@store/customer/customer.actions';

export const initialCustomer: CustomerState = {
  customer: null,
  isLoading: false,
  preLoan: null,
  redirectUrl: null,
  error: false,
  validation: null,
  id: null,
  isLoadingPreLoan: false,
  cardInfo: null,
};

const _customerReducer = createReducer(
  initialCustomer,
  on(customerActions.requestCustomerInformation, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(customerActions.successRequestCustomerInformation, (state, { customer }) => {
    return {
      ...state,
      isLoading: false,
      customer,
    };
  }),
  on(customerActions.failureRequestCustomerInformation, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  }),
  on(customerActions.listenUserScore, (state) => {
    return {
      ...state,
      isLoading: true,
      error: false,
    };
  }),
  on(customerActions.successListenUserScore, (state, { validation }) => {
    return {
      ...state,
      isLoading: false,
      validation,
      error: false,
    };
  }),
  on(customerActions.failureListenUserScore, (state) => {
    return {
      ...state,
      isLoading: false,
      error: true,
    };
  }),
  on(customerActions.setCustomerInformation, (state, { customer }) => {
    return {
      ...state,
      isLoading: false,
      customer,
    };
  }),
  on(customerActions.requestPreLoan, (state) => {
    return {
      ...state,
      isLoading: true,
      error: false,
    };
  }),
  on(customerActions.successRequestPreLoan, (state, { preLoan }) => {
    return {
      ...state,
      isLoading: false,
      preLoan,
      error: false,
    };
  }),
  on(customerActions.failureRequestPreLoan, (state) => {
    return {
      ...state,
      isLoading: false,
      error: true,
    };
  }),
  on(customerActions.createPreLoan, (state) => {
    return {
      ...state,
      isLoadingPreLoan: true,
      error: false,
    };
  }),
  on(customerActions.successCreatePreLoan, (state, { id }) => {
    return {
      ...state,
      id,
      error: false,
    };
  }),
  on(customerActions.updateIsLoadingPreLoan, (state, { isLoadingPreLoan }) => {
    return {
      ...state,
      isLoadingPreLoan,
    };
  }),
  on(customerActions.failureCreatePreLoan, (state) => {
    return {
      ...state,
      isLoadingPreLoan: false,
      error: true,
    };
  }),
  on(customerActions.getCustomerCard, (state) => {
    return {
      ...state,
      isLoading: true,
      error: false,
    };
  }),
  on(customerActions.successGetCustomerCard, (state, { cardInfo }) => {
    return {
      ...state,
      cardInfo,
      isLoading: false,
      error: false,
    };
  }),
  on(customerActions.failureGetCustomerCard, (state) => {
    return {
      ...state,
      isLoading: false,
      error: false,
    };
  }),
  on(customerActions.setCustomerValidate, (state, { validation }) => {
    return {
      ...state,
      validation,
    };
  })
);

export function customerReducers(state: CustomerState | undefined, action: Action) {
  return _customerReducer(state, action);
}
